import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Navbar from './components/Navbar';
import Header from './components/Header';
import MovieList from './components/MovieList';
import reqParams from './Requests';
import TvShows from './components/TvShows';
import Login from './components/Login';
import { UserAuth } from './AuthContext';
import { useEffect } from 'react';


function App() {

  const{user} = UserAuth();


  return (
    <div className="App">
      {!user && <Login/>}
      <Navbar/>
      <Header/>
        
      <MovieList url={reqParams.topTrending}  title={"Trending Movies"}/>
      <MovieList url={reqParams.topRatedMovies} title={"TopRated Movies"}/>
      <MovieList url={reqParams.HindiMovies} title={"Hindi Movies"}/>
      <MovieList url={reqParams.ActionMovies} title={"Action Movies"}/>
      <MovieList url={reqParams.ComedyMovies} title={"Comedy Movies"}/>
      <MovieList url={reqParams.HorrorMovies} title={"Horror Movies"}/>
      <MovieList url={reqParams.RomanticMoves} title={"Romantic Movies"}/>
      <TvShows url={reqParams.topRatedTvShows} title={"Top Rated Tv Shows"} />
     
  
    </div>
    
    
  );
}

export default App;
